// client/src/config/vendors.ts
//
// The scheduling vendor list shipped HIDDEN (Nick, 2026-10-07: "D3 hidden first") and was un-hidden for MANAGERS
// ONLY on Nick's ruling on #6761. Since 2026-10-15 (Nick) it is a TAB inside Project Settings, not a page of its own.
// While this is false there is no Vendors tab and no /projects/vendors address. With it true, Project Settings shows
// the Vendors tab to managers/admins who are not outside-contractor accounts (useVisibleTabs in
// pages/Projects/ProjectSettings.tsx; see vendorsAccess.test.tsx), and /projects/vendors forwards to
// /projects/settings?tab=vendors. Hiding is NOT access control: the projects_createVendor / projects_updateVendor /
// projects_setVendorActive callables and firestore.rules gate who can read and change the list whatever this says.
export const VENDORS_ADMIN_ENABLED = true;
